import { render } from "./apply_for_trial.vue?vue&type=template&id=39d6adf9"
import script from "./apply_for_trial.vue?vue&type=script&lang=js"
export * from "./apply_for_trial.vue?vue&type=script&lang=js"
script.render = render

export default script